import { Action, createAction, props } from '@ngrx/store';
import { LayoutState } from '../reducers/layout.reducer';


export enum LayoutActionTypes {
  LoadLayouts = '[Layout] Load Layouts',
  AllTilesRequested = '[Header Tiles] All Header Tiles Requested',
  AllTilesLoaded = '[Tiles API] All Tiles Loaded',
  DefaultTabSelection = '[Layout] Default Tab Selection',
  TabClick = '[Layout] Tab Click',
  ShowRightSideSplitter = '[Layout] Open Or Close Right Side Splitter',
  IsHeaderMenuVisible = '[Header Menu] Show or Hide Header Menu',
  RoutedTab = "[Layout] RoutedTab"
}

export const LoadLayouts = createAction(LayoutActionTypes.LoadLayouts,
  (layoutState: LayoutState) => ({ payload: { layoutState } }));

export const AllTilesRequested = createAction(LayoutActionTypes.AllTilesRequested);
export const AllTilesLoaded = createAction(LayoutActionTypes.AllTilesLoaded,
  props<{ tiles: any[] }>());
export const DefaultTabSelection = createAction(LayoutActionTypes.DefaultTabSelection,
  props<{ tabName: string }>());
export const TabClick = createAction(LayoutActionTypes.TabClick,
  props<{ selectedTile: any }>());
export const ShowRightSideSplitter = createAction(LayoutActionTypes.ShowRightSideSplitter,
  props<{ isOpen: boolean }>());
export const IsHeaderMenuVisible = createAction(LayoutActionTypes.IsHeaderMenuVisible,
  props<{ isVisible: boolean }>());
export const RoutedTab = createAction(LayoutActionTypes.RoutedTab,
  props<{ routedTab: string }>());
